import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const getDirectDebitFile = (invoiceIds, addPayments) => {
    return RESTClient.postAuthenticatedObservable('v2/invoicing/direct-debit', {
        invoiceIds: invoiceIds.toJSON(),
        addPayments: addPayments ? 1 : 0,
    });
};
